<template>
  <v-dialog v-model="open" width="600px" scrollable>
    <v-card flat>
      <v-toolbar elevation="0">
        <v-toolbar-title class="pl-3 text--subtitle">
          <v-icon color="primary" style="padding-bottom: 2px"
            >mdi-security</v-icon
          >
          {{ edit ? 'Editar' : 'Criar' }} grupo de segurança
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pt-4">
        <v-text-field
          v-model="group.name"
          autofocus
          outlined
          hide-details
          dense
          :label="$t('message.name')"
          required
          counter="50"
          color="primary"
          @keyup.enter="handleConfirm"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="px-8 pb-6">
        <v-spacer></v-spacer>
        <v-btn
          text
          class="mr-4 px-4"
          :disabled="isFetching"
          @click="handleClose"
        >
          {{ $t('message.cancel') }}
        </v-btn>
        <v-btn
          large
          class="primary white--text"
          min-width="185px"
          @click="handleConfirm"
          :loading="isFetching"
          :disabled="isFetching"
        >
          {{ $t('message.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmCreateGroup',
  components: {},
  data: () => ({
    open: false,
    edit: false,
    isFetching: false,
    groupId: '',
    selectedDrmValue: { text: '0%', value: 0 },
    group: {
      name: '',
      percentTs: 0,
      fontFamily: 'arial',
      fontColor: '#FFFFFFFF',
      fontSize: 26,
      boxColor: '#7999CEFF',
      boxOpacity: 1,
    },
    folderId: '',
  }),
  watch: {
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },
  mounted() {
    this.$root.$on('openDrmCreateGroup', (data) => {
      Object.assign(this.$data, this.initialState())
      if (data?.edit) {
        this.edit = data.edit
        this.groupId = data.item.id
        this.group.name = data.item.name
        this.group.percentTs = data.item.percent_ts
        this.group.fontFamily = data.item.config['font-family'] || 'arial'
        this.group.fontColor = data.item.config['font-color']
        this.group.fontSize = data.item.config['font-size']
        this.group.boxColor = data.item.config['box-color']
        this.group.boxOpacity = data.item.config['box-opacity']
      }
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('folderModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    handleConfirm() {
      let groupObject = {
        name: this.group.name,
        percent_ts: this.group.percentTs,
        'font-family': this.group.fontFamily.toString(),
        'font-color': this.group.fontColor.toString(),
        'font-size': this.group.fontSize.toString(),
        'box-color': this.group.boxColor.toString(),
        'box-opacity': this.group.boxOpacity.toString(),
      }
      if (this.edit) {
        this.handleEdit(groupObject)
      } else {
        this.handleCreate(groupObject)
      }
    },
    async handleCreate(groupObject) {
      this.isFetching = true
      groupObject.video_ids = []
      groupObject.active = false
      try {
        let ret = await drmApi.createDrmGroup(groupObject)
        let newGroup = ret.data
        newGroup.video_ids = []
        this.$root.$emit('addNewDrmGroup', newGroup)
        this.handleClose()
      } catch (e) {
        console.log('e', e)
      }
      this.isFetching = false
    },
    async handleEdit(groupObject) {
      this.isFetching = true
      console.log('xd', groupObject)
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.$root.$emit('updateDrmGroup', ret.data)
        this.handleClose()
        console.log('ret update', ret)
      } catch (e) {
        console.log('e', e)
      }
      this.isFetching = false
    },
    handleClose() {
      this.open = false
    },
    handleEnter() {
      this.edit ? this.handleEdit() : this.handleCreate()
    },
    initialState() {
      return {
        open: false,
        edit: false,
        isFetching: false,
        groupId: '',
        selectedDrmValue: { text: '0%', value: 0 },
        group: {
          name: '',
          percentTs: 0,
          fontFamily: 'fredoka-regular',
          fontColor: '#FFFFFFFF',
          fontSize: 12,
          boxColor: '#7999CEFF',
          boxOpacity: 1,
        },
        folderId: '',
      }
    },
  },
}
</script>

<style lang="scss">
.bgImg {
  background-image: url('../../assets/pandaVideoScreenShot.jpg');
  background-size: contain;
}
</style>
